module.exports = __webpack_public_path__ + "static/media/ex2.a60ce99e.jpg";